import { render, staticRenderFns } from "./PlatformPreview.vue?vue&type=template&id=95349410"
import script from "./PlatformPreview.vue?vue&type=script&lang=js"
export * from "./PlatformPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports